import { createSelector } from '@reduxjs/toolkit';
import { currentOpenChatSelector } from '../currentOpenChatSelector';

export const currentChatActiveReplyMessageIdSelector = createSelector(
  [currentOpenChatSelector],
  currentOpenChat => currentOpenChat?.activeReplyMessage?.messageId,
);
